import { useAuth } from '../App';

const TIERS = [
  {
    key: 'free',
    name: 'Free',
    price: 0,
    period: 'forever',
    features: [
      'Best Odds comparison (50 matches)',
      '5 Value Bets per day',
      'Top 3 Arb opportunities',
      'All 7 Calculators',
      'Betting Education Guide',
      'Basic Telegram Bot',
    ],
  },
  {
    key: 'edge',
    name: 'Edge',
    price: 99,
    period: 'per month',
    yearly: 'P890/year — save 25%',
    featured: true,
    features: [
      'Best Odds — all matches',
      '20 Value Bets per day',
      'Full Arb Scanner',
      'Smart Parlay Builder',
      'CLV Tracker',
      'Bankroll Manager',
      'Full Telegram Bot access',
      'Kelly stake recommendations',
    ],
  },
  {
    key: 'elite',
    name: 'Elite',
    price: 199,
    period: 'per month',
    yearly: 'P1,790/year — save 25%',
    features: [
      'Everything in Edge',
      'Unlimited Value Bets',
      'Automatic push alerts',
      'Tipster Hub access',
      'Betting Heat Map',
      'Monthly performance report',
      'Priority support',
    ],
  },
];

export default function Billing() {
  const { user } = useAuth();
  const currentPlan = user?.plan || 'free';
  const isMobile = window.innerWidth < 768;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

      {/* Current plan summary */}
      <div className="card" style={{ padding: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <div style={{ fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>Current Plan</div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 26 }}>
              {TIERS.find(t => t.key === currentPlan)?.name || 'Free'}
            </div>
            <div style={{ fontSize: 13, color: 'var(--text3)', marginTop: 4 }}>
              {currentPlan === 'free'
                ? 'Upgrade to unlock the full platform'
                : 'Your subscription renews automatically'}
            </div>
          </div>
          <span className={`pill pill-${currentPlan === 'edge' ? 'teal' : currentPlan === 'elite' ? 'amber' : 'blue'}`} style={{ fontSize: 11 }}>
            {currentPlan.toUpperCase()}
          </span>
        </div>
      </div>

      {/* Launch banner */}
      <div style={{
        padding: '16px 20px', background: 'rgba(0,229,176,0.06)',
        border: '1px solid rgba(0,229,176,0.2)', borderRadius: 'var(--radius)',
        display: 'flex', alignItems: 'center', gap: 14,
      }}>
        <div style={{ fontSize: 24 }}>🎉</div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 2 }}>Launch offer — full access free</div>
          <div style={{ fontSize: 13, color: 'var(--text3)' }}>All new accounts get complete platform access during our launch period. No card required.</div>
        </div>
      </div>

      {/* Pricing tiers */}
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)', gap: 16 }}>
        {TIERS.map(tier => {
          const isCurrent = tier.key === currentPlan;
          return (
            <div
              key={tier.key}
              className="card"
              style={{
                padding: 24,
                border: tier.featured ? '2px solid var(--accent)' : isCurrent ? '1px solid var(--accent)' : '1px solid var(--border)',
                position: 'relative',
              }}
            >
              {tier.featured && (
                <div style={{
                  position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
                  background: 'var(--accent)', color: '#080d17',
                  fontSize: 10, fontWeight: 700, padding: '3px 14px', borderRadius: 20,
                  fontFamily: 'var(--font-display)', whiteSpace: 'nowrap',
                }}>Most popular</div>
              )}

              <div style={{ fontSize: 11, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 10 }}>{tier.name}</div>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 32, marginBottom: 2 }}>
                <span style={{ fontSize: 16 }}>P</span>{tier.price}
              </div>
              <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 4 }}>{tier.period}</div>
              {tier.yearly && <div style={{ fontSize: 11, color: 'var(--accent)', marginBottom: 16 }}>{tier.yearly}</div>}
              {!tier.yearly && <div style={{ marginBottom: 16 }} />}

              <div style={{ height: 1, background: 'var(--border)', marginBottom: 14 }} />

              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
                {tier.features.map((f, i) => (
                  <div key={i} style={{ display: 'flex', gap: 8, fontSize: 12, color: 'var(--text2)' }}>
                    <span style={{ color: 'var(--accent)', flexShrink: 0 }}>✓</span>
                    {f}
                  </div>
                ))}
              </div>

              {isCurrent ? (
                <button className="btn btn-outline" disabled style={{ width: '100%', fontSize: 12, opacity: 0.6 }}>
                  Current Plan
                </button>
              ) : (
                <button
                  className={tier.featured ? 'btn btn-primary' : 'btn btn-outline'}
                  style={{ width: '100%', fontSize: 12 }}
                  onClick={() => alert('Billing integration coming soon — contact support@oddsedgebw.co.bw to upgrade during launch period.')}
                >
                  {tier.price === 0 ? 'Downgrade' : 'Upgrade'}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Billing history placeholder */}
      <div className="card" style={{ padding: 24 }}>
        <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 15, marginBottom: 12 }}>Billing History</div>
        <div style={{ padding: '24px 0', textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
          No billing history yet — you're currently on the free launch period.
        </div>
      </div>

      <div style={{ fontSize: 12, color: 'var(--text3)', textAlign: 'center', padding: '8px 0' }}>
        Questions about billing? Email <a href="mailto:support@oddsedgebw.co.bw" style={{ color: 'var(--accent)' }}>support@oddsedgebw.co.bw</a>
      </div>
    </div>
  );
}